import React, { memo, useState, useCallback, useEffect, useRef } from 'react';
import classNames from 'classnames';

import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import styles from './Category.module.less';
import { logging } from '../../actions/log';
// import { useLocation } from 'react-router-dom';
// import qs from 'query-string';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(({ getActive, categoryList, showResidual, showNotOftenUsedSofts, active }) => {
  const dispatch = useDispatch();
  // const location = useLocation();
  // const search = qs.parse(location.search) || {};
  const logInfoData = useSelector(selectLogInfo);
  // const [active, setActive] = useState(search.tag || 'all_zw');
  const [showcategoryList, setShowCategoryList] = useState([]);
  const activeRef = useRef(null);

  useEffect(() => {
    activeRef.current = active;
  }, [active]);
  useEffect(() => {
    const temp = [{ name: '全部', id: 'all_zw' }];
    if (showResidual) {
      temp.push({ name: '待清理残留项', id: 'residual' });
    }
    if (showNotOftenUsedSofts) {
      temp.push({ name: '不常用软件', id: 'not_often_used_softs' });
    }

    if (categoryList && categoryList.length === 1 && categoryList[0].id === '9999') {
      setShowCategoryList(temp);
    } else {
      setShowCategoryList([...temp, ...categoryList]);
    }
  }, [categoryList, showResidual, showNotOftenUsedSofts]);
  useEffect(() => {
    // 展现打桩
    if (showResidual) {
      dispatch(
        logging({
          category: 'I',
          action: 'Mysofts_App_Setting',
          label: '',
          param2: {
            source: `Mysofts_Classify`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            type: 'uninstall',
          },
        }),
      );
    }
    if (showNotOftenUsedSofts) {
      dispatch(
        logging({
          category: 'I',
          action: 'Mysofts_App_Setting',
          label: '',
          param2: {
            source: `Mysofts_Classify`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            type: 'less',
          },
        }),
      );
    }
  }, [showResidual, showNotOftenUsedSofts]);

  const handleClick = useCallback(
    (item = 'all_zw') => {
      dispatch(
        logging({
          category: 'C',
          action: 'Mysofts_Classify',
          label: '',
          param2: {
            source: `Mysofts_Classify||${item === 'all_zw' ? '-1' : item}`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
          },
        }),
      );

      // setActive(item);
      getActive(item);
      const el = document.getElementById('container_content');
      if (el) {
        el.scrollTo(0, 0);
      }
    },
    [logInfoData, getActive],
  );
  useEffect(() => {
    const target = showcategoryList.find(item => item.id === activeRef.current);
    if (!target) {
      handleClick('all_zw');
    }
  }, [showcategoryList]);
  if (!showcategoryList || showcategoryList.length <= 1) {
    return <></>;
  }
  if (
    categoryList &&
    categoryList.length === 1 &&
    categoryList[0].id === '9999' &&
    showcategoryList.length < 2
  ) {
    return <></>;
  }
  return (
    <>
      <div
        className={classNames(
          styles.category,
          {
            [styles.category_residual]:
              (!showResidual && showNotOftenUsedSofts) || (showResidual && !showNotOftenUsedSofts),
          },
          {
            [styles.category_residual_not_ofte_use]: showResidual && showNotOftenUsedSofts,
          },
        )}
      >
        {showcategoryList.map((item, index) => {
          return (
            <React.Fragment key={item.id}>
              {index === 1 && showResidual && (
                <div
                  className={classNames(styles.item, styles.clear_item, styles.clear_item_text, {
                    [styles.active]: active === 'residual',
                  })}
                  onClick={() => {
                    handleClick('residual');
                  }}
                >
                  {active !== 'residual' && (
                    <i className={classNames('iconfont icon-tips', styles.icon_tips)} />
                  )}
                  {item.name}
                </div>
              )}
              {(index !== 1 || !showResidual) && (
                <div
                  className={classNames(
                    styles.item,
                    // 判断此项是不是不常用软件
                    {
                      [styles.other_item1]: index === 1 && !showResidual && showNotOftenUsedSofts,
                    },
                    {
                      [styles.other_item2]: index === 2 && showResidual && showNotOftenUsedSofts,
                    },
                    { [styles.active]: item.id === active },
                  )}
                  onClick={() => {
                    handleClick(item.id);
                  }}
                >
                  {item.name}
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </>
  );
});
